export enum LayerLevel {
	Construction = -1,
	Inside = 0,
	Middle = 1,
	Outside = 2
}

